"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.PatientLandingWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.PatientLandingWrap = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding-bottom: 12px;
  max-width: 312px;
  margin: 0 auto;

  * {
    margin: 0;
    box-sizing: border-box;
  }

  h1 {
    max-width: 254px;
    align-self: flex-start;
  }

  .landing-patient-main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  .landing-patient-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
  }

  @media screen and (min-width: 768px) {
    max-width: 688px;
    h1 {
      max-width: 688px;
    }
  }

  @media screen and (min-width: 1000px) {
    max-width: 920px;
    padding-bottom: 28px;

    h1 {
      max-width: 839px;
    }

    .landing-patient-row {
      flex-direction: row;
    }
  }

  @media screen and (min-width: 1300px) {
    max-width: 1220px;
    padding-bottom: 40px;

    h1 {
      max-width: 1150px;
    }
  }

  @media screen and (min-width: 1690px) {
    max-width: 1354px;
    padding-bottom: 50px;
  }

  @media screen and (min-width: 1920px) {
    max-width: 1584px;
    padding-bottom: 61px;
  }
`;
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  border-radius: 18px;
  background-color: white;
  width: fit-content;

  h3 {
    font-family: Phenomena, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
    text-align: left;
    color: #7b4ef8;
  }

  p {
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    text-align: left;
  }

  .landing-patient-container-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    justify-content: flex-start;
  }

  svg {
    min-width: 74px;
    width: 74px;
    height: auto;
  }

  &.landing-patient-chat {
    position: relative;
    padding: 181px 16px 16px 16px;
    margin-top: 12px;

    img {
      position: absolute;
      width: 184px;
      height: 174px;
      top: 6px;
      left: 50%;
      transform: translateX(-50%);
    }

    p {
      max-width: 273px;
      font-family: Phenomena, sans-serif;
      font-size: 24px;
      font-weight: 700;
      line-height: 29px;
      text-align: left;
      color: #7b4ef8;
    }
  }

  &.landing-patient-1 {
    max-width: 312px;
  }

  &.landing-patient-2 {
    max-width: 274px;
  }

  &.landing-patient-3 {
    max-width: 296px;
  }

  &.landing-patient-4 {
    max-width: 300px;
  }

  &.landing-patient-5 {
    max-width: 267px;
  }

  &.landing-patient-6 {
    max-width: 256px;
  }

  @media screen and (min-width: 768px) {
    flex-direction: row;
    gap: 16px;
    padding: 16px;
    border-radius: 18px;

    h3 {
      font-size: 24px;
      line-height: 29px;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      line-height: 19px;
    }

    .landing-patient-container-info {
      gap: 8px;
    }

    svg {
      min-width: 74px;
      width: 74px;
      height: auto;
    }

    &.landing-patient-chat {
      padding: 19px 16px 19px 181px;
      margin-top: 24px;

      img {
        position: absolute;
        width: 153px;
        height: 143px;
        top: 22px;
        left: 14px;
        transform: none;
      }

      p {
        max-width: 451px;
        font-size: 40px;
        line-height: 48px;
      }
    }

    &.landing-patient-1 {
      max-width: 688px;
      padding: 24px;
    }

    &.landing-patient-2 {
      max-width: 598px;
    }

    &.landing-patient-3 {
      max-width: 667px;
    }

    &.landing-patient-4 {
      max-width: 450px;
    }

    &.landing-patient-5 {
      max-width: 641px;
    }

    &.landing-patient-6 {
      max-width: 580px;
    }
  }

  @media screen and (min-width: 1000px) {
    flex-direction: row;
    gap: 16px;
    padding: 16px;
    border-radius: 18px;

    h3 {
      font-size: 24px;
      line-height: 29px;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      line-height: 19px;
    }

    .landing-patient-container-info {
      gap: 8px;
    }

    svg {
      min-width: 74px;
      width: 74px;
      height: auto;
    }

    &.landing-patient-chat {
      padding: 19px 16px 19px 181px;
      margin-top: 38px;

      img {
        position: absolute;
        width: 153px;
        height: 143px;
        top: 22px;
        left: 14px;
        transform: none;
      }

      p {
        max-width: 451px;
        font-size: 40px;
        line-height: 48px;
      }
    }

    &.landing-patient-1 {
      max-width: 920px;
      padding: 24px;
    }

    &.landing-patient-2 {
      max-width: 376px;
    }

    &.landing-patient-3 {
      max-width: 519px;
    }

    &.landing-patient-4 {
      max-width: 450px;
    }

    &.landing-patient-5 {
      max-width: 448px;
    }

    &.landing-patient-6 {
      padding: 19px 16px;
      max-width: 810px;
    }
  }

  @media screen and (min-width: 1300px) {
    gap: 24px;
    padding: 24px;
    border-radius: 24px;

    h3 {
      font-size: 42px;
      line-height: 50px;
    }

    p {
      font-size: 24px;
      font-weight: 500;
      line-height: 29px;
    }

    .landing-patient-container-info {
      gap: 12px;
    }

    svg {
      min-width: 110px;
      width: 110px;
      height: auto;
    }

    &.landing-patient-chat {
      padding: 24px 24px 24px 252px;
      margin-top: 38px;

      img {
        position: absolute;
        width: 216px;
        height: 203px;
        top: 41px;
        left: 13px;
        transform: none;
      }

      p {
        max-width: 720px;
        font-size: 64px;
        line-height: 77px;
      }
    }

    &.landing-patient-1 {
      max-width: 1220px;
      padding: 24px;
    }

    &.landing-patient-2 {
      max-width: 588px;
    }

    &.landing-patient-3 {
      max-width: 609px;
    }

    &.landing-patient-4 {
      max-width: 638px;
    }

    &.landing-patient-5 {
      max-width: 533px;
    }

    &.landing-patient-6 {
      padding: 24px;
      max-width: 870px;
    }
  }

  @media screen and (min-width: 1690px) {
    gap: 24px;
    padding: 24px;
    border-radius: 24px;

    h3 {
      font-size: 42px;
      line-height: 50px;
    }

    p {
      font-size: 24px;
      font-weight: 500;
      line-height: 29px;
    }

    .landing-patient-container-info {
      gap: 12px;
    }

    svg {
      min-width: 110px;
      width: 110px;
      height: auto;
    }

    &.landing-patient-chat {
      padding: 24px 24px 24px 252px;
      margin-top: 48px;

      img {
        position: absolute;
        width: 216px;
        height: 203px;
        top: 41px;
        left: 13px;
        transform: none;
      }

      p {
        max-width: 720px;
        font-size: 64px;
        line-height: 77px;
      }
    }

    &.landing-patient-1 {
      max-width: 1354px;
      padding: 24px;
      font-size: 27px;
      line-height: 33px;
    }

    &.landing-patient-2 {
      max-width: 588px;
    }

    &.landing-patient-3 {
      max-width: 721px;
    }

    &.landing-patient-4 {
      max-width: 638px;
    }

    &.landing-patient-5 {
      max-width: 701px;
    }

    &.landing-patient-6 {
      padding: 24px;
      max-width: 870px;
    }
  }

  @media screen and (min-width: 1920px) {
    gap: 24px;
    padding: 24px;
    border-radius: 24px;

    h3 {
      font-size: 42px;
      line-height: 50px;
    }

    p {
      font-size: 24px;
      font-weight: 500;
      line-height: 29px;
    }

    .landing-patient-container-info {
      gap: 12px;
    }

    svg {
      min-width: 110px;
      width: 110px;
      height: auto;
    }

    &.landing-patient-chat {
      padding: 24px 24px 24px 252px;
      margin-top: 58px;

      img {
        position: absolute;
        width: 216px;
        height: 203px;
        top: 41px;
        left: 13px;
        transform: none;
      }

      p {
        max-width: 720px;
        font-size: 64px;
        line-height: 77px;
      }
    }

    &.landing-patient-1 {
      max-width: 1584px;
      padding: 24px;
      font-size: 27px;
      line-height: 33px;
    }

    &.landing-patient-2 {
      max-width: 690px;
    }

    &.landing-patient-3 {
      max-width: 818px;
    }

    &.landing-patient-4 {
      max-width: 730px;
    }

    &.landing-patient-5 {
      max-width: 701px;
    }

    &.landing-patient-6 {
      padding: 24px;
      max-width: 870px;
    }
  }
`;
